import { Link, useNavigate, useLocation } from 'react-router-dom';

export function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (sectionId: string) => {
    if (location.pathname === '/') {
      // 이미 홈페이지에 있으면 바로 스크롤
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // 다른 페이지에 있으면 홈페이지로 이동 후 스크롤
      navigate('/');
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold text-emerald-600" style={{ fontFamily: '"Pacifico", serif' }}>
              라코스벨
            </Link>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              <Link to="/" className="text-gray-700 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                홈
              </Link>
              <button 
                onClick={() => handleNavigation('about')}
                className="text-gray-700 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                회사소개
              </button>
              <button 
                onClick={() => handleNavigation('products')}
                className="text-gray-700 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                제품
              </button>
              <button 
                onClick={() => handleNavigation('contact')}
                className="text-gray-700 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer"
              >
                연락처
              </button>
            </div>
          </div>
          
          <div className="md:hidden">
            <button className="text-gray-700 hover:text-emerald-600 cursor-pointer">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}